import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateSellInvoice from './ModalCreateSellInvoice'
import TableSellInvoices from '../../../../../../../specificComponents/sells/TableSellInvoice'
import { Link } from 'react-router-dom'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../../baseComponents/Button'
import locations from '../../../../../../../utils/globals/locations'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../baseComponents/Modal'
import { getConfigParam, getUserPermissions } from '../../../../../../../utils/reducers/getters'
import { useCallback, useMemo } from 'react'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../utils/hooks/useEditDeleteModal'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'
import { twinFetchPostText } from '../../../../../../../utils/globals/data'
import useUpdateTableInstance from '../../../../../../../utils/hooks/useUpdateTableInstance'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { BaseScreenPageData } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'

interface SellInvoicesProps extends ComponentWithPermissions { }

const SellInvoices: React.FC<SellInvoicesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const pageData = {
        title: t('invoices', 'Facturas'),
        newText: t('newInvoice', 'Nueva factura'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableSellInvoices} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateSellInvoice} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderSellInvoices {...{ updateTableInstance, setOpenModal, pageData }} />
        }>
        </BaseScreenTableSimpleStateless>
    )
}

interface RightHeaderSellInvoicesProps {
    pageData: BaseScreenPageData
    setOpenModal: SetEditDeleteModalTy
    updateTableInstance: () => void
}

const RightHeaderSellInvoices: React.FC<RightHeaderSellInvoicesProps> = ({ pageData, updateTableInstance, setOpenModal}) => {
    const haveWordpress = useMemo(() => getConfigParam('wordpressSpecificRuleId'), [])
    const editModalInner = useEditDeleteModal()
    return (
        <div className='flex items-center ml-auto'>
            {haveWordpress && permissionCheck(getUserPermissions('sell.invoice.importInvoices'), 'read') ? <ButtonSecondary className='mr-10' onClick={() => { editModalInner.setOpenModal({ type: 'edit', allRowData: {} }) }}><TwinTrans transKey='importWordpressInvoices'>Importar facturas de wordpress</TwinTrans></ButtonSecondary> : null}
            <Link to={locations.sellInvoiceMulti + '/main'}><ButtonSecondary className='mr-10'><TwinTrans transKey='generateMultiInvoice'> Generar factura múltiple</TwinTrans></ButtonSecondary></Link>
            {editModalInner.openModal?.type === 'edit' ? <ModalImportWordpressInvoices setOpened={() => editModalInner.setOpenModal(null)} onSubmit={updateTableInstance} /> : null}
            {pageData.newText ? <ButtonPrimary onClick={async () => setOpenModal({ type: 'create', allRowData: {} })}> <span><TwinIcon icon={faPlus} className='mr-8' />{pageData.newText}</span></ButtonPrimary>: null}
        </div>
    )
}


interface ModalImportWordpressInvoicesProps extends ModalImportWordpressInvoicesLogicProps {
}

const ModalImportWordpressInvoices: React.FC<ModalImportWordpressInvoicesProps> = ({ setOpened, ...rest }) => {
    const {t} = useTwinTranslation()
    const { loading, importInvoicesWordpress } = useModalImportWordpressInvoicesLogic({ setOpened, ...rest })
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} onClickOut={false}>
            <h2><TwinTrans transKey='importWordpressInvoices'>Importar facturas de Wordpress</TwinTrans></h2>
            <span> <TwinTrans transKey='sureImportWordpressInvoices'>¿Seguro que quieres importar las facturas desde wordpress?</TwinTrans></span>
            <ButtonsModalSmallCentered loading={loading} confirmText={t('accept', 'Aceptar')} setOpened={() => setOpened(null)} onAccept={importInvoicesWordpress}></ButtonsModalSmallCentered>
        </ ModalSmallCentered>
    )
}

interface ModalImportWordpressInvoicesLogicProps extends ModalEditComponentProps {
}

const useModalImportWordpressInvoicesLogic = ({ onSubmit, setOpened }: ModalImportWordpressInvoicesLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const importInvoicesWordpress = useCallback(async () => {
        startLoading()
        const res = await twinFetchPostText('/api/app/order/sell/sellInvoice/importOrdersFromWordpress', {})
        if (res) {
            await onSubmit?.(res, {})
        }
        endLoading()
        setOpened(null)
    }, [startLoading, endLoading, setOpened, onSubmit])
    return { loading, importInvoicesWordpress }
}

export default SellInvoices